import { api } from '@/lib/api';

/** V4.9.20 — Admin storage API (local disk + Google Drive). */
export interface StorageStatus {
  backend: 'local' | 'gdrive';
  active_backend: 'local' | 'gdrive';
  drive_configured: boolean;
  config_source: 'db' | 'env' | 'none';
  client_email: string | null;
  folder_id: string | null;
  counts: { local: number; gdrive: number };
  local_disk_bytes: number | null;
  drive_quota: { limit: number | null; usage: number | null } | null;
  encryption_ready: boolean;
  /** Stored creds present but undecryptable (encryption key missing/rotated). */
  credentials_unreadable: boolean;
}

export interface ConnectResult {
  saved: boolean;
  connected: boolean;
  message: string;
  client_email: string;
  folder_name: string | null;
  quota: { limit: number | null; usage: number | null } | null;
}

export interface StorageTestResult {
  ok: boolean;
  message: string;
  folder_name?: string | null;
  quota?: { limit: number | null; usage: number | null } | null;
}

export interface OffloadResult {
  migrated: number;
  failed: number;
  freed_bytes: number;
  remaining: number;
  errors: { id: string; error: string }[];
}

export const storageApi = {
  status: () => api.get<StorageStatus>('/storage/status'),
  test: () => api.post<StorageTestResult>('/storage/test', {}, { timeout: 60_000 }),
  offload: (limit?: number) =>
    api.post<OffloadResult>('/storage/offload', { limit }, { timeout: 180_000 }),
  // V4.9.21 — connect Google Drive from the app (service-account JSON + folder id).
  connect: (service_account_json: string, folder_id: string) =>
    api.put<ConnectResult>('/storage/config', { service_account_json, folder_id }, { timeout: 60_000 }),
  disconnect: () => api.post<{ success: true; message: string }>('/storage/disconnect', {})
};
